import {FilterList} from '@mui/icons-material';
import {Dialog, DialogContent, IconButton, useMediaQuery} from '@mui/material';
import {FC, useMemo, useState} from 'react';
import {styled} from 'styled-components';

import {FilterForm} from '@website_frontend/components/filter_form';
import {LoadingState} from '@website_frontend/components/loading_state';
import {VirtualizedHouseGrid} from '@website_frontend/components/virtualized_house_grid';
import {useDbData} from '@website_frontend/lib/db_cache';
import {itemMatchesFilters, useFilters} from '@website_frontend/lib/filters';

export const HomePage: FC = () => {
  const {data, state} = useDbData();
  const isMobile = useMediaQuery('(max-width: 512px)');
  const [filtersOpen, setFiltersOpen] = useState(false);
  const {filters} = useFilters();

  const filteredIds = useMemo(() => {
    if (!data) return undefined;
    return data.filter(item => itemMatchesFilters(item, filters));
  }, [data, filters]);

  if (!filteredIds) {
    return <LoadingState state={state} data={data} />;
  }

  return (
    <Wrapper>
      {filteredIds && (
        <>
          <FloatingMenu>
            <IconButton onClick={() => setFiltersOpen(true)}>
              <FilterList />
            </IconButton>
          </FloatingMenu>
          <Dialog
            fullScreen={isMobile}
            maxWidth={false}
            open={filtersOpen}
            onClose={() => setFiltersOpen(false)}
            PaperProps={{sx: {maxWidth: 450}}}
          >
            <DialogContent
              sx={{
                padding: 0,
                height: isMobile ? '100%' : 'auto',
                maxHeight: isMobile ? '100%' : '90vh',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <FilterForm
                onApply={() => setFiltersOpen(false)}
                filteredItemCount={filteredIds?.length}
              />
            </DialogContent>
          </Dialog>
          <GridWrapper>
            <VirtualizedHouseGrid ids={filteredIds} />
          </GridWrapper>
        </>
      )}
    </Wrapper>
  );
};
HomePage.displayName = 'HomePage';

const Wrapper = styled.div`
  position: relative;
  width: 100vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FloatingMenu = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  padding: 6px;
  backdrop-filter: blur(5px);
  background-color: #ffffff33;
  z-index: 1000;
  border-radius: 50%;
`;

const GridWrapper = styled.div`
  flex-grow: 1;
  height: 0;
  width: 100%;
`;
